import { FieldInputProps } from 'formik'
import { useColorMode } from '@chakra-ui/react'

export const useBorderColor = (field: FieldInputProps<any>) => {
  const { colorMode } = useColorMode()
  const filledBorderColor = colorMode === 'dark' ? 'dark.3' : 'dark.2'
  const emptyBorderColor = colorMode === 'dark' ? 'dark.2' : 'dark.4'
  return field.value ? filledBorderColor : emptyBorderColor
}
